import Logotype from "./Logotype";
import { NAMES, SIZES, TYPES } from "./utilities";

export { NAMES, SIZES, TYPES };
export default Logotype;
